import { ADD_ITEM_TO_WISHLIST_FAILURE, ADD_ITEM_TO_WISHLIST_REQUEST, ADD_ITEM_TO_WISHLIST_SUCCESS, GET_WISHLIST_FAILURE, GET_WISHLIST_REQUEST, GET_WISHLIST_SUCCESS, IS_WISHLIST_ITEM_EXIST_FAILURE, IS_WISHLIST_ITEM_EXIST_REQUEST, IS_WISHLIST_ITEM_EXIST_SUCCESS, REMOVE_WISHLIST_ITEM_FAILURE, REMOVE_WISHLIST_ITEM_REQUEST, REMOVE_WISHLIST_ITEM_SUCCESS } from "./ActionType";


const initialState = {
    wishlist: null,
    existWishlistItem: false,
    loading: false,
    wishLoading: false,
    error: null,
    wishlistItems: [],
}

export const wishlistReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_ITEM_TO_WISHLIST_REQUEST:
            return { ...state, wishLoading: true, error: null };

        case ADD_ITEM_TO_WISHLIST_SUCCESS:
            return { ...state, wishlistItems: [...state.wishlistItems, action.payload.wishlistItems], addWislistItem: action.payload, wishLoading: false, error: null };

        case ADD_ITEM_TO_WISHLIST_FAILURE:
            return { ...state, wishLoading: false, error: action.payload };

        case GET_WISHLIST_REQUEST:
            return { ...state, loading: true, error: null };

        case GET_WISHLIST_SUCCESS:
            return { ...state, wishlistItems: action.payload.wishlistItems, wishlist: action.payload, loading: false, error: null };

        case GET_WISHLIST_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case IS_WISHLIST_ITEM_EXIST_REQUEST:
            return { ...state, loading: true, error: null };

        case IS_WISHLIST_ITEM_EXIST_SUCCESS:
            return { ...state, existWishlistItem: action.payload, loading: false, error: null };

        case IS_WISHLIST_ITEM_EXIST_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case REMOVE_WISHLIST_ITEM_REQUEST:
            return { ...state, wishLoading: true, error: null };

        case REMOVE_WISHLIST_ITEM_SUCCESS:
            return {
                ...state,
                wishlistItems: state.wishlistItems.filter(item => item?.product?.id !== action.payload), // ✅ Remove from UI
                deletedWishlistItem: action.payload,
                wishLoading: false,
                error: null
            };

        case REMOVE_WISHLIST_ITEM_FAILURE:
            return { ...state, wishLoading: false, error: action.payload };

        default:
            return state;
    }
}